/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VerticalTreeNode } from '../../models/vertical-tree-node';

export interface GetTreeStructure$Params {
}

export function getTreeStructure(http: HttpClient, rootUrl: string, params?: GetTreeStructure$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VerticalTreeNode>>> {
  const rb = new RequestBuilder(rootUrl, getTreeStructure.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VerticalTreeNode>>;
    })
  );
}

getTreeStructure.PATH = '/api/Organizations/verticaltree';
